import { useEffect, useState } from "react";
import MasterLayout from "./MasterLayout";
import { masterFetch } from "./masterApi";
import API_URL from "../../utils/apiUrl";
import { masterAuth } from "./masterApi";

export default function MasterCompliance() {
  const [tenants, setTenants] = useState([]);
  const [err, setErr] = useState("");

  async function load() {
    try { setTenants((await masterFetch("/tenants")).tenants || []); }
    catch (e) { setErr(e.message); }
  }
  useEffect(() => { load(); }, []);

  async function sign(t) {
    const signer = window.prompt(`Sign DPA for ${t.name} — signer name:`);
    if (!signer) return;
    await masterFetch(`/compliance/tenants/${t.id}/sign-dpa`, {
      method: "POST", body: JSON.stringify({ signer_name: signer })
    });
    load();
  }

  function exportTenant(t) {
    const tok = masterAuth.getToken();
    fetch(`${API_URL}/api/master/compliance/tenants/${t.id}/export`, {
      headers: { Authorization: `Bearer ${tok}` }
    }).then(r => r.blob()).then(b => {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(b);
      a.download = `tenant-${t.id}.json`;
      a.click();
    });
  }

  async function expireGrace() {
    if (!window.confirm("Run grace expiration cron now? Any tenant past its 30-day grace will be auto-nuked.")) return;
    const r = await masterFetch("/compliance/cron/expire-grace", { method: "POST" });
    alert(`Nuked: ${r.count}`);
    load();
  }

  return (
    <MasterLayout>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 style={{ margin: 0, fontSize: 26 }}>Compliance</h1>
        <button data-testid="run-grace" onClick={expireGrace} style={btnGhost}>Run grace-expire cron</button>
      </div>
      <div style={{ opacity: 0.55, fontSize: 13, marginBottom: 22 }}>GDPR/CCPA controls per tenant.</div>

      {err && <div style={{ padding: 12, background: "rgba(255,80,90,0.1)", border: "1px solid rgba(255,80,90,0.4)", color: "#ff7886", borderRadius: 8, fontSize: 13, marginBottom: 12 }}>{err}</div>}

      <div data-testid="compliance-table" style={{ background: "#0f0a1c", border: "1px solid #1f1232", borderRadius: 12, overflow: "hidden" }}>
        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1.5fr 1fr 2fr", padding: "12px 16px", fontSize: 11, letterSpacing: 2, opacity: 0.5, borderBottom: "1px solid #1f1232" }}>
          <span>TENANT</span><span>REGION</span><span>DPA</span><span>STATUS</span><span style={{textAlign:"right"}}>ACTIONS</span>
        </div>
        {tenants.map(t => (
          <div key={t.id} data-testid={`compliance-row-${t.id}`} style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1.5fr 1fr 2fr", padding: "12px 16px", borderBottom: "1px solid #1a1029", alignItems: "center", fontSize: 13 }}>
            <span><div style={{ fontWeight: 500 }}>{t.name}</div><div style={{ opacity: 0.4, fontSize: 11 }}>{t.owner_email}</div></span>
            <span style={{ opacity: 0.7 }}>{t.data_region}</span>
            <span>{t.dpa_signed_at ? (
              <span style={{ color: "#34d399" }}>✓ v{t.dpa_version} · {new Date(t.dpa_signed_at).toLocaleDateString()}</span>
            ) : <span style={{ color: "#f87171" }}>unsigned</span>}</span>
            <span style={{ opacity: 0.7 }}>{t.status}</span>
            <span style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
              {!t.dpa_signed_at && <button onClick={() => sign(t)} style={btnSmall}>Sign DPA</button>}
              <button onClick={() => exportTenant(t)} style={btnSmall}>Export</button>
            </span>
          </div>
        ))}
      </div>
    </MasterLayout>
  );
}

const btnGhost = { padding: "9px 14px", background: "transparent", color: "#a89ec9", border: "1px solid #3a2a55", borderRadius: 8, cursor: "pointer", fontSize: 12, fontFamily: "inherit" };
const btnSmall = { padding: "5px 10px", background: "transparent", color: "#a89ec9", border: "1px solid #3a2a55", borderRadius: 6, cursor: "pointer", fontSize: 11, fontFamily: "inherit" };
